<template>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        style="margin-top: 6px"
        size="small"
        label-width="100px"
    >
        <el-form-item label="发件用户名" prop="user">
            <el-input v-model="form.user" style="width: 40%" />
            <span style="color: #c0c0c0; margin-left: 10px"
                >Sender username</span
            >
        </el-form-item>
        <el-form-item label="授权码" prop="authpwd">
            <el-input
                v-model="form.authpwd"
                type="password"
                style="width: 40%"
            />
            <span style="color: #c0c0c0; margin-left: 10px">email Authpwd</span>
        </el-form-item>
        <el-form-item label="SMTP地址" prop="host">
            <el-input v-model="form.host" style="width: 40%" />
            <span style="color: #c0c0c0; margin-left: 10px">SMTP address</span>
        </el-form-item>
        <el-form-item label="">
            <el-button
                :loading="loading"
                size="medium"
                type="primary"
                @click="doSubmit"
                >保存配置</el-button
            >
        </el-form-item>
    </el-form>
</template>

<script>
import { getEmailList, updateEmail } from '@/network/other/email'
export default {
    name: 'Config',
    data() {
        return {
            loading: false,
            form: {
                user: '',
                authpwd: '',
                host: ''
            },
            rules: {
                user: [
                    {
                        required: true,
                        message: '请输入发件用户名',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: '请输入正确的邮箱地址',
                        trigger: 'blur'
                    }
                ],
                authpwd: [
                    {
                        required: true,
                        message: '授权码不能为空',
                        trigger: 'blur'
                    }
                ],
                host: [
                    {
                        required: true,
                        message: 'SMTP地址不能为空',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    created() {
        this.getInitData()
    },
    methods: {
        getInitData() {
            getEmailList().then(res => {
                let data = res.data.data
                if (data != null) {
                    this.form = res.data.data
                }
            })
        },
        doSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    updateEmail(this.form)
                        .then(res => {
                            this.getInitData()
                            this.$message.success('操作成功')
                            this.loading = false
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.success('操作失败')
                        })
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
</style>
